import { create } from "zustand";
import { persist } from "zustand/middleware";
const GeneralKey = "general";
export const useSurveyLastSeenStore = create()(persist((set, get) => ({
    survey: {},
    setSurveyLastSeen: (surveyId, userId = GeneralKey) => {
        set((state) => {
            const seenRecord = state.survey[surveyId] || {};
            seenRecord[userId] = Date.now();
            return {
                survey: {
                    ...state.survey,
                    [surveyId]: seenRecord,
                },
            };
        });
    },
    getSurveyLastSeen(surveyId, userId = GeneralKey) {
        const seenRecord = get().survey[surveyId] || {};
        return seenRecord[userId];
    },
}), {
    name: "posthog-survey-seen",
    serialize: (store) => JSON.stringify(store.state.survey),
    deserialize: (str) => ({ state: { survey: JSON.parse(str) } }),
}));
